import { TokenTypes } from "@/types/token.type";

import hungerApi from "../../api/hunger.api";
import { postIdToSwitchGroupAction } from "../groupReducer/groupActions";

import {
  getUserInforActions,
  logOutActions,
  postEmailForLoginActions,
  setLoadingActions,
} from "./mrgActions";
import {
  GetUesrInforType,
  PostCodeForLoginType,
  PostEmailForLoginType,
} from "./mrgTypes";

export const logOut = (): ThunkActionTypes => (dispatch) => {
  localStorage.removeItem(TokenTypes.ACCESS_TOKEN);
  localStorage.removeItem(TokenTypes.ID_TOKEN);
  localStorage.removeItem(TokenTypes.VALIDATE_TOKEN);
  dispatch(logOutActions());
};

// noinspection JSUnusedGlobalSymbols
export const setLoading =
  (loading: boolean): ThunkActionTypes =>
  async (dispatch) => {
    dispatch(setLoadingActions(loading));
  };

export const postEmailForLogin =
  (email: string, recaptchaToken: string): ThunkActionTypes =>
  async (dispatch) => {
    const { data } = await hungerApi.post<PostEmailForLoginType>(
      "/api/v3/p/auth/mgt/issue",
      {
        email,
        recaptchaToken,
      }
    );

    localStorage.setItem(TokenTypes.VALIDATE_TOKEN, data.validateToken);
    dispatch(postEmailForLoginActions(email));
  };

export const postCodeForLogin =
  (code: string): ThunkActionTypes =>
  async (_) => {
    const validateToken: string = localStorage.getItem(
      TokenTypes.VALIDATE_TOKEN
    )!;
    const { data } = await hungerApi.post<PostCodeForLoginType>(
      "/api/v3/p/auth/mgt/validate",
      {
        code,
        validateToken,
      }
    );
    localStorage.setItem(TokenTypes.ACCESS_TOKEN, data.token);
  };

export const getUserInfor =
  (): ThunkActionTypes<Promise<void>> => async (dispatch) => {
    const {
      data: { name, email, group },
    } = await hungerApi.get<GetUesrInforType>("/api/v3/mgt/me");
    dispatch(getUserInforActions({ name, email }));
    dispatch(postIdToSwitchGroupAction(group));
  };
